// extracted by mini-css-extract-plugin
export default {"container":"CompareSorts_container__8kQQN","table":"CompareSorts_table__wJVaM","status":"CompareSorts_status__Z+yhE"};